import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BulkSelectEmployeeDialogComponent } from '@app/components';
import { AnalyticEvents } from '@app/enums';
import { Employee } from '@app/models/employee/employee.model';
import { DataField } from '@app/models/settings/data-field.model';
import { AssignedEmployeesAndInteractableFieldValuesTable } from '@app/modules/settings/services/tables/assigned-employees-and-interactable-field-values-table/assigned-employees-and-interactable-field-values.table';
import { AnalyticService, AuthService, NotifyService } from '@app/services';
@Component({
    templateUrl: './assign-employees.template.html',
    styleUrls: ['./assign-employees.style.scss'],
})
export class AssignEmployeesView {
    @ViewChild('assignEmployeesModal', { static: true }) assignEmployeesModal: BulkSelectEmployeeDialogComponent;

    isLoading = false;

    field: DataField;
    assignedEmployeesAndInteractableFieldValuesTable: AssignedEmployeesAndInteractableFieldValuesTable;

    constructor(
        public auth: AuthService,
        private route: ActivatedRoute,
        private notify: NotifyService,
        private router: Router,
        private analyticsService: AnalyticService
    ) {
        this.field = this.route.snapshot.data.models.get('field');

        this.assignedEmployeesAndInteractableFieldValuesTable = new AssignedEmployeesAndInteractableFieldValuesTable(
            this.auth,
            this.field,
            this.analyticsService
        );
    }

    onDone(): void {
        this.router.navigate(['/settings', 'custom-fields', 'fields']);
    }

    async onAssignEmployees(): Promise<void> {
        const assignedEmployees = this.field.employees;

        try {
            const selectedEmployees: Employee[] = await this.assignEmployeesModal.show<Employee[] | null>(
                assignedEmployees
            );

            if (selectedEmployees) {
                this.isLoading = true;

                this.field.employeeIds = selectedEmployees.map((employee) => employee.id);

                try {
                    const field = await this.field.param('company', this.auth.company.id).save();
                    this.getFieldDetails(field);

                    this.analyticsService.trackEvent(AnalyticEvents.SettingsModuleAssignCustomField);

                    this.notify.success('Updated custom field.');
                } catch (err) {
                    this.notify.error(err);
                } finally {
                    this.assignedEmployeesAndInteractableFieldValuesTable.reload();
                    this.isLoading = false;
                }
            }
        } catch (err) {
            this.notify.error(err);
        }
    }

    // This method is used to fetch field details along with other details such as account, employee, role etc.
    private async getFieldDetails(field: DataField): Promise<void> {
        try {
            this.field = await DataField.param('company', this.auth.company.id)
                .with(['roles', 'viewOnlyRoles', 'employees', 'employees.account'])
                .find(field.id);
        } catch (err) {
            this.notify.error(err);
        }
    }
}
